/**
 * SHOPIFY THEME CUSTOM JAVASCRIPT
 * Includes: Swiper, GSAP Animations, AJAX Cart, Video Popup, Slick
 */

document.addEventListener('DOMContentLoaded', function () {
    
    /* ==========================================
       1. HERO SLIDER (Swiper)
       ========================================== */
    const initHomeSlider = () => {
        const sliderId = 'home-slider-{{ section.id }}';
        const swiperElement = document.getElementById(sliderId);
        if (swiperElement && typeof Swiper !== 'undefined') {
            new Swiper(swiperElement, {
                loop: true,
                slidesPerView: 1,
                effect: 'fade',
                fadeEffect: { crossFade: true },
                speed: 1000,
                autoplay: { delay: 5000, disableOnInteraction: false },
                navigation: {
                    nextEl: `#${sliderId} .swiper-button-next`,
                    prevEl: `#${sliderId} .swiper-button-prev`,
                },
                pagination: {
                    el: `#${sliderId} .swiper-pagination`,
                    clickable: true,
                }
            });
        }
    };

    /* ==========================================
       2. VIDEO POPUP SYSTEM
       ========================================== */
    const initVideoPopup = () => {
        const popup = document.getElementById('videoPopup');
        const iframe = document.getElementById('popupIframe');
        const openBtns = document.querySelectorAll('.js-open-video');
        const closeBtn = document.querySelector('.close_video_popup_button');
        const overlay = document.querySelector('.video-popup .overlay');

        if (!popup || !iframe) return;

        const closePopup = () => {
            popup.classList.remove('active');
            iframe.src = '';
            document.body.style.overflow = '';
        };

        openBtns.forEach(btn => {
            btn.addEventListener('click', function() {
                let url = this.getAttribute('data-video');
                if(url.includes('youtube.com/watch?v=')) {
                    url = url.replace('watch?v=', 'embed/') + '?autoplay=1';
                } else if(url.includes('youtu.be/')) {
                    url = url.replace('youtu.be/', 'youtube.com/embed/') + '?autoplay=1';
                }
                iframe.src = url;
                popup.classList.add('active');
                document.body.style.overflow = 'hidden';
            });
        });

        if (closeBtn) closeBtn.addEventListener('click', closePopup);
        if (overlay) overlay.addEventListener('click', closePopup);
    };

    /* ==========================================
       3. GSAP SCROLL ANIMATIONS
       ========================================== */
    const initGSAPAnimations = () => {
        if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
        gsap.registerPlugin(ScrollTrigger);

        const section = document.querySelector(".pf-single-about");
        if (!section) return;

        const image = section.querySelector(".pf-image");
        const content = section.querySelector(".pf-content");

        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

        gsap.set(image, { x: -150, opacity: 0 });
        gsap.set(content, { x: 150, opacity: 0 });

        gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "top 85%",
                end: "bottom 15%",
                scrub: 1,
                invalidateOnRefresh: true
            }
        })
        .to([image, content], { x: 0, opacity: 1, ease: "power2.out", duration: 1 })
        .to([image, content], { x: (i) => i === 0 ? -150 : 150, opacity: 0, ease: "power2.in", duration: 1 }, "+=0.5");
    };

    /* ==========================================
       4. INTERSECTION OBSERVER (Lazy Anims)
       ========================================== */
    const initLazySections = () => {
        const sections = document.querySelectorAll(".lazy-section");
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                entry.target.classList.toggle("anim-active", entry.isIntersecting);
            });
        }, { threshold: 0.25 });

        sections.forEach(s => observer.observe(s));
    };

    /* ==========================================
       5. PRICE RANGE SLIDER SYNC
       ========================================== */
    const initPriceFilters = () => {
        const rangeMin = document.getElementById("rangeMin");
        const rangeMax = document.getElementById("rangeMax");
        const inputMin = document.getElementById("inputMin");
        const inputMax = document.getElementById("inputMax");

        if (!rangeMin || !rangeMax) return;

        const minGap = 10;
        const updateInputs = () => {
            let minVal = parseInt(rangeMin.value);
            let maxVal = parseInt(rangeMax.value);
            if (maxVal - minVal < minGap) {
                rangeMin.value = maxVal - minGap;
            }
            inputMin.value = rangeMin.value;
            inputMax.value = rangeMax.value;
        };

        rangeMin.addEventListener("input", updateInputs);
        rangeMax.addEventListener("input", updateInputs);
    };

    /* ==========================================
       6. RUN INITIALIZERS
       ========================================== */
    initHomeSlider();
    initVideoPopup();
    initGSAPAnimations();
    initLazySections();
    initPriceFilters();
    
    // Initialize secondary swipers
    if(document.querySelector(".aboutSwiper")) {
        new Swiper(".aboutSwiper", {
            slidesPerView: 4, spaceBetween: 20, loop: true, autoplay: { delay: 2500 },
            breakpoints: { 0: { slidesPerView: 1.2 }, 768: { slidesPerView: 2.5 }, 1024: { slidesPerView: 4 } }
        });
    }
});

/* ==========================================
   7. AJAX CART ENGINE (Side Drawer)
   ========================================== */

const formatMoney = (cents) => '₹ ' + (cents / 100).toLocaleString('en-IN');

async function refreshCartUI() {
    try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        const container = document.getElementById("cart-items-container");
        const totalEl = document.getElementById("drawer-total-price");

        if (!cart.items.length) {
            container.innerHTML = '<p class="empty-msg">Your cart is empty.</p>';
            totalEl.textContent = formatMoney(0);
            return;
        }

        container.innerHTML = cart.items.map(item => `
            <div class="cart-row" data-key="${item.key}">
                <div class="cart-image"><img src="${item.image}" width="60"></div>
                <div class="cart-info">
                    <h4>${item.product_title}</h4>
                    <div class="qty-stepper">
                        <button onclick="updateDrawerQty('${item.key}', ${item.quantity - 1})">−</button>
                        <input type="number" value="${item.quantity}" readonly>
                        <button onclick="updateDrawerQty('${item.key}', ${item.quantity + 1})">+</button>
                    </div>
                    <span>${formatMoney(item.final_line_price)}</span>
                </div>
            </div>
        `).join('');
        totalEl.textContent = formatMoney(cart.total_price);
    } catch (e) { console.error("UI Update Failed", e); }
}

async function updateDrawerQty(key, qty) {
    const container = document.getElementById("cart-items-container");
    container.style.opacity = "0.4";
    await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
    });
    refreshCartUI();
    container.style.opacity = "1";
}

function openCartDrawer() {
    document.getElementById("side-cart-drawer").classList.add("is-open");
    document.getElementById("cart-overlay").classList.add("is-visible");
    document.body.style.overflow = "hidden";
    refreshCartUI();
}

function closeCartDrawer() {
    document.getElementById("side-cart-drawer").classList.remove("is-open");
    document.getElementById("cart-overlay").classList.remove("is-visible");
    document.body.style.overflow = "";
}

// Global Click Listener for Add to Cart
document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.add-to-cart-btn');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    const variantId = btn.dataset.variantId;
    const card = btn.closest('.delicio-product-card');
    const qty = card ? parseInt(card.querySelector('.qty-input').value) : 1;

    btn.innerText = "Adding...";
    btn.disabled = true;

    try {
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: qty })
        });
        btn.innerText = "Added ✓";
        openCartDrawer();
    } catch (err) {
        btn.innerText = "Error";
    } finally {
        setTimeout(() => { btn.innerText = "Add to cart"; btn.disabled = false; }, 1500);
    }
});

/* ==========================================
   8. SLICK SLIDER (With Positioning)
   ========================================== */
const initSlick = () => {
    if (window.jQuery && jQuery.fn.slick) {
        const applySlidePositions = () => {
            document.querySelectorAll('.slider-content').forEach(el => {
                el.style.top = el.dataset.top || '20%';
                el.style.left = el.dataset.left || '12%';
            });
        };

        $('.main-slider').not('.slick-initialized').on('init afterChange', applySlidePositions).slick({
            dots: false, infinite: true, speed: 700, fade: true, cssEase: 'ease-in-out'
        });
        applySlidePositions();
    } else {
        setTimeout(initSlick, 200); // Retry if jQuery isn't ready
    }
};
initSlick();





